import { ConstructClassWithPrivateMembers } from '../../../../../../misc/helpers/ClassWithPrivateMembers';
import { FROM_ITERABLE_OBSERVABLE_PRIVATE } from './privates';
import { HasFactoryWaterMark } from '../../../../../../classes/class-helpers/factory';
import { IsObject } from '../../../../../../helpers';
export function ConstructFromIterableObservable(instance, args) {
    ConstructClassWithPrivateMembers(instance, FROM_ITERABLE_OBSERVABLE_PRIVATE);
    const privates = instance[FROM_ITERABLE_OBSERVABLE_PRIVATE];
    privates.iterable = args.iterable;
    privates.isAsync = args.isAsync;
}
export function IsFromIterableObservable(value) {
    return IsObject(value)
        && value.hasOwnProperty(FROM_ITERABLE_OBSERVABLE_PRIVATE);
}
export const IS_FROM_ITERABLE_OBSERVABLE_CONSTRUCTOR = Symbol('is-from-iterable-observable-constructor');
export function IsFromIterableObservableConstructor(value) {
    return (typeof value === 'function')
        && HasFactoryWaterMark(value, IS_FROM_ITERABLE_OBSERVABLE_CONSTRUCTOR);
}
//# sourceMappingURL=constructor.js.map